/**
 * Internal dependencies
 */
import BlockSearch from './block-search';
import ViewportManager from "./viewport-manager";

/**
 * 
 */
class BlockSearchManager {
	
	/**
	 * @type Document
	 */
	contextDocument = document;

	/**
	 * @type BlockSearch[]
	 */
	blockSearchList = [];

	/**
	 * @type String
	 */
	blockSearchSelector = '.block-search';

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onViewportChange = this.onViewportChange.bind( this );
		document.addEventListener( 'WMUViewportChange', this.onViewportChange );
	}

	/**
	 * 
	 */
	clear()
	{
		this.blockSearchList.forEach( ( blockSearch ) =>
		{
			blockSearch.clear();
		} );

		this.blockSearchList = [];
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	setup( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = this.contextDocument;
		}

		contextElement.querySelectorAll( this.blockSearchSelector ).forEach( ( element ) =>
		{
			if ( ! element.wmuBlockSearch )
			{
				const args = {
					ajaxUrl: wmuwpb.ajaxUrl,
					nonce: wmuwpb.blockSearch.nonce,
					action: wmuwpb.blockSearch.action,
					/**
					 * @todo A passer en option du block / en config générale
					 */
					searchOnFocus: true,
					// overlayScrollCustomBehavior: ( -1 === [ 'vs', 'vm' ].indexOf( ViewportManager.getCurrentViewport() ) ),
					overlayScrollCustomBehavior: true,
					overlayScrollSelector: ( -1 !== [ 'vs', 'vm' ].indexOf( ViewportManager.getCurrentViewport() ) )
						? '.block-search-form-results' : '.block-search-results-wrapper',
				};

				if ( wmuwpb.lang )
				{
					args.requestArgs = {
						lang: wmuwpb.lang,
					}
				}

				const blockSearch = new BlockSearch( element, args );
				blockSearch.setup();
				this.blockSearchList.push( blockSearch );
			}
		} );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onViewportChange( event )
	{
		this.clear();
		this.setup();
	}

}

export default BlockSearchManager;